import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { faqs } from '../mock';
import { Plus } from 'lucide-react';

export default function FAQ() {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [openId, setOpenId] = useState(faqs[0].id);

  return (
    <section id="faq" className="py-28 md:py-40 bg-[#0D1612] relative overflow-hidden" data-testid="faq-section">
      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7 }}
            className="lg:col-span-4"
          >
            <span className="inline-block text-emerald-400 font-semibold text-sm uppercase tracking-[0.25em] mb-5">
              / Questions
            </span>
            <h2 className="font-display text-4xl md:text-5xl font-black text-white leading-[0.95] mb-4">
              Still not<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-lime-400">sure?</span>
            </h2>
            <p className="text-slate-400">Everything you need to know before we get started together.</p>
          </motion.div>

          <div className="lg:col-span-8">
            {faqs.map((faq, index) => {
              const isOpen = openId === faq.id;
              return (
                <motion.div
                  key={faq.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={inView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.5, delay: index * 0.05 }}
                  className="border-b border-white/[0.08]"
                  data-testid={`faq-item-${faq.id}`}
                >
                  <button
                    onClick={() => setOpenId(isOpen ? null : faq.id)}
                    className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                    data-testid={`faq-trigger-${faq.id}`}
                  >
                    <span className={`font-display text-lg md:text-xl font-semibold transition-colors duration-300 ${isOpen ? 'text-emerald-400' : 'text-white group-hover:text-emerald-300'}`}>
                      {faq.question}
                    </span>
                    <span className={`flex-shrink-0 w-9 h-9 rounded-full border flex items-center justify-center transition-all duration-300 ${isOpen ? 'border-emerald-400 bg-emerald-500/10 rotate-45' : 'border-white/15 group-hover:border-emerald-400/50'}`}>
                      <Plus className={`w-4 h-4 transition-colors duration-300 ${isOpen ? 'text-emerald-400' : 'text-slate-400'}`} />
                    </span>
                  </button>
                  <motion.div
                    initial={false}
                    animate={{ height: isOpen ? 'auto' : 0, opacity: isOpen ? 1 : 0 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    className="overflow-hidden"
                  >
                    <p className="text-slate-400 leading-relaxed pb-6 pr-16">{faq.answer}</p>
                  </motion.div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
